import { AuthErrorCode } from './auth-errors';

/**
 * Maps an Auth0 redirect/callback error onto a login_error query code.
 * Auth0 Actions deny unregistered users with access_denied + "not registered" in the message.
 */
export function mapAuth0ErrorToLoginErrorCode(error: {
  message?: string;
  error?: string;
}): AuthErrorCode {
  const message = error.message ?? '';
  if (/not registered/i.test(message)) {
    return 'ERR_USER_NOT_REGISTERED';
  }
  return 'ERR_AUTH_FAILED';
}
